import React, { useState } from "react";

import styled from "styled-components";
import {Container, Slide} from "@mui/material";
import ArrowRightIcon from "../icons/ArrowRightIcon";
import { media } from "../../../styles/styles";

const StyledContainer = styled(Container)`
  min-height: 400px;
  position: relative;
  text-align: center;
  padding: 2rem;
  overflow: hidden;
`;
const ArrowRight = styled(ArrowRightIcon)`
  path {
    fill: #e55934;
  }
`;
const ArrowLeft = styled(ArrowRightIcon)`
  transform: rotate(180deg);
  path {
    fill: #e55934;
  }
`;
const ButtonLeft = styled.button`
  position: absolute;
  left: 0;
  top: calc(50% - 20px);
  cursor: pointer;
  background: transparent;
  border: none;
  z-index: 3;
`;
const ButtonRight = styled.button`
  position: absolute;
  right: 0;
  top: calc(50% - 20px);
  cursor: pointer;
  background: transparent;
  border: none;
  z-index: 3;
`;
const Content = styled.div`
  position: absolute;
  right: calc(50% - 300px);
  ${media.tablet`
  right: 0;
  `};
  font-size: 1rem;
  max-width: 600px;
  ${media.tablet`
     padding:0 1rem;
  `};
`;

type Directions = {
  enter: "right" | "left";
  exit: "right" | "left";
};
export default function Carousel({ blocks, sectionTitle, ...other }) {
  const [blockIndex, setBlockIndex] = useState(0);
  const [direction, setDirection] = useState<Directions>({
    enter: "right",
    exit: "left",
  });
  return (
    <StyledContainer {...other}>
      <ButtonLeft
        onClick={() => {
          setDirection({ enter: "right", exit: "left" });
          setBlockIndex(blockIndex === 0 ? blocks.length - 1 : blockIndex - 1);
        }}
        type="button"
        aria-label="Previous quote"
      >
        <ArrowLeft />
      </ButtonLeft>
      {sectionTitle}
      {blocks.map((content, index) => (
        <Slide
          direction={blockIndex === index ? direction.enter : direction.exit}
          in={blockIndex === index}
          mountOnEnter
          unmountOnExit
          key={`slider-${index}`}
          timeout={{ enter: 500, exit: 300, appear: 1500 }}
        >
          <Content>{content}</Content>
        </Slide>
      ))}
      <ButtonRight
        onClick={() => {
          setDirection({ enter: "left", exit: "right" });
          setBlockIndex(blocks.length === blockIndex + 1 ? 0 : blockIndex + 1);
        }}
        type="button"
        aria-label="Next quote"
      >
        <ArrowRight />
      </ButtonRight>
    </StyledContainer>
  );
}
